<ng-container *ngIf="countBadge > 0">
  <div class="Oval animated fadeIn fast">
    <ion-label mode="md" color="white">{{ countBadge }}</ion-label>
  </div>
</ng-container>
